import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/our-story-zeelool/components/SwiperComponent.tsx");
